var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChipError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30168 1.70817C4.82576 1.70817 2.00798 4.52596 2.00798 8.00188C2.00798 11.4778 4.82576 14.2956 8.30168 14.2956C11.7776 14.2956 14.5954 11.4778 14.5954 8.00188C14.5954 4.52596 11.7776 1.70817 8.30168 1.70817ZM0.609375 8.00188C0.609375 3.75353 4.05334 0.30957 8.30168 0.30957C12.55 0.30957 15.994 3.75353 15.994 8.00188C15.994 12.2502 12.55 15.6942 8.30168 15.6942C4.05334 15.6942 0.609375 12.2502 0.609375 8.00188Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00798 8.00188C2.00798 4.52596 4.82576 1.70817 8.30168 1.70817C11.7776 1.70817 14.5954 4.52596 14.5954 8.00188C14.5954 11.4778 11.7776 14.2956 8.30168 14.2956C4.82576 14.2956 2.00798 11.4778 2.00798 8.00188Z",
    fill: "#F44336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97843 5.12216L11.1821 10.3258L10.6245 10.8833L5.4209 5.67969L5.97843 5.12216Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4209 10.3252L10.6245 5.12156L11.1821 5.67909L5.97843 10.8827L5.4209 10.3252Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipError);
export default __webpack_public_path__ + "static/media/chip__error.20df216c194280ba9af09eb3d7eaa290.svg";
export { ForwardRef as ReactComponent };